function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2]);
}

window.setCookie = function (cname, cvalue, exhours) {
  var d = new Date();
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000); // Convert hours to ms
  var expires = "expires=" + d.toUTCString();        // Use UTC string
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.getCookie = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var cookieArray = decodedCookie.split(";");
  for (var i = 0; i < cookieArray.length; i++) {
    var cookieItem = cookieArray[i];
    while (cookieItem.charAt(0) === " ") {
      cookieItem = cookieItem.substring(1);
    }
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.substring(name.length, cookieItem.length);
    }
  }
  return "";
};

$(document).ready(function(){
  settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .closeBtn",
    objModalDataAttr: "data-popup"
  }  
  $(settings.objModalPopupBtn).bind("click", function () {
    if ($(this).attr(settings.objModalDataAttr)) {
      var strDataPopupName = $(this).attr(settings.objModalDataAttr);    
      //Fade In Modal Pop Up
      $(".overlay, #" + strDataPopupName).fadeIn();
      $('body').addClass('overflow-hidden');
    }
  });
  
  //On clicking the modal background
  $(settings.objModalCloseBtn).bind("click", function () {
    $(".modal").fadeOut();
    $('body').removeClass('overflow-hidden');
  });
})